import { GetServerSidePropsContext, NextPage } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import RedirectToHome from '@/organisms/redirect-to-home';
import Rental from '@/organisms/rental';
import { useGetSelectedLocationType } from '@core/offices/actions/properties/filterActions';
import getPropertiesProps from '@core/offices/actions/properties/getPropertiesProps';
import { usePropertyFilters } from '@core/offices/store/filters';
import { useSettingsStore } from '@core/settings/store/settings';
import { OfficePaginator, PropertyType } from '@graphql/hooks-and-types';

const RentalMapViewPage: NextPage<{
  filteredPropertiesPaginator: OfficePaginator;
  locationTypes: string[];
  propertyTypes: PropertyType[];
  error?: string;
}> = (props) => {
  const { isUnitsEnabled } = useSettingsStore();
  const { setLocationType } = usePropertyFilters();
  const locationType = useGetSelectedLocationType();
  const router = useRouter();
  const { t } = useTranslation();

  useEffect(() => {
    if (!isUnitsEnabled) {
      router.push(`/home?clientName=${router.query.clientName}`);
    }
    if (!router.query.locationType && props.locationTypes.length > 0) {
      setLocationType(props.locationTypes[0]);
    }
  }, []);

  useEffect(() => {
    if (locationType) {
      router.replace(
        `/rentals?clientName=${router.query.clientName}&locationType=${locationType}&address=${
          router.query.address || ''
        }`,
      );
    }
  }, [locationType]);

  if (!isUnitsEnabled) return <RedirectToHome message={t('rentals.notAllowedMeetingRoom')} />;

  if (props.error) {
    return <div>{props.error}</div>;
  }

  return (
    <div className="w-full">
      <Rental locationTypes={props.locationTypes} filteredPropertiesPaginator={props.filteredPropertiesPaginator} />
    </div>
  );
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  return getPropertiesProps(context.query);
}

export default RentalMapViewPage;
